/* ResetPassword.js */

import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import apiUrl from '../config';
import '../CSS/Resetpassword.css';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const token = new URLSearchParams(location.search).get('token');

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setNotification({
        open: true,
        message: 'Veuillez renseigner les deux champs de mot de passe.',
        severity: 'error',
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      setNotification({
        open: true,
        message: 'Les mots de passe ne correspondent pas.',
        severity: 'error',
      });
      return;
    }

    if (newPassword.length < 8) {
      setNotification({
        open: true,
        message: 'Le mot de passe doit contenir au moins 8 caractères.',
        severity: 'error',
      });
      return;
    }

    setLoading(true);

    try {
      let response;

      if (token) {
        response = await axios.post(`${apiUrl}/set-password?token=${encodeURIComponent(token)}`, {
          password: newPassword
        });
      } else {
        if (!email) {
          setNotification({
            open: true,
            message: "L'email est requis.",
            severity: 'error',
          });
          setLoading(false);
          return;
        }

        response = await axios.put(`${apiUrl}/reset-password`, {
          email: email.trim().toLowerCase(),
          new_password: newPassword
        });
      }

      if (response.status === 200) {
        setNotification({
          open: true,
          message: 'Mot de passe mis à jour avec succès.',
          severity: 'success',
        });

        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 2000);
      }

    } catch (error) {
      setNotification({
        open: true,
        message: error.response?.data?.message || 'Erreur lors de la réinitialisation du mot de passe.',
        severity: 'error',
      });

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-container">
      <div className="reset-logo-container">
        <img
          src="/BIAM Consulting Main Logo.png"
          alt="Logo BIAM Consulting"
          className="reset-logo"
        />
      </div>

      <h2>
        {token ? 'Création / réinitialisation du mot de passe' : 'Réinitialisation du mot de passe'}
      </h2>

      <form onSubmit={handleSubmit}>
        {!token && (
          <input
            type="email"
            placeholder="Votre email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        )}

        <input
          type="password"
          placeholder="Nouveau mot de passe"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Confirmer le mot de passe"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Validation...' : 'Valider le mot de passe'}
        </button>
      </form>

      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          severity={notification.severity}
          sx={{
            width: '100%',
            fontSize: '1rem',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
          }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ResetPassword;